export type { FooterElementProps } from './types';
export * from './footer-element';
